<label class="container" [ngClass]="!control.value ? 'disabled' : ''">{{ title }}
  <input type="checkbox" [formControl]="control">
  <span class="checkmark"></span>
</label>